import CCBCCLogo from '@/assets/branding/ccbcc/logo.png';

const colors = {
  // Brand colors
  brand_primary: '#004D55',
  brand_primary_hover: '#011E21', // -10 L, -8 S
  brand_primary_highlight: '#00B7CA', // +23 L, +7 S
  brand_primary_mid: '#00727E', // +8 L,  +2 S
  brand_primary_dark: '#000000', // -25 L, -3 S (clamped)
  brand_secondary: '#010708', // hue +4 deg, -15 L, -13 S
  brand_accent_start: '#0B6771',
  brand_accent_end: '#A14A3A',
  brand_accent_light_start: '#E6F3F4',
  brand_accent_light_end: '#F6ECEA',
  brand_complementary_accent: 'rgb(202,75,43)',
  brand_auth_gradient_mid: '#010708',
  brand_auth_gradient_end: '#000000',
  brand_auth_warp_mid: '#00727E',
};

export default {
  name: 'CCBCC',
  isSAML: true,
  allowPersonalCourses: false,
  logo: CCBCCLogo,
  colors,
};
